export default "__VITE_ASSET__2e16af4f__"